let HKD = [
    {
        'label': '中西區',
        'value': 'ZXQ',
        'parent': 'HKD'
    },{
        'label': '南區',
        'value': 'NQ',
        'parent': 'HKD'
    },{
        'label': '東區',
        'value': 'DQ',
        'parent': 'HKD'
    },{
        'label': '灣仔區',
        'value': 'WZQ',
        'parent': 'HKD'
    }
];

let JiuLong = [
    {
        'label': '九龍城區',
        'value': 'JLCQ',
        'parent': 'JL'
    },{
        'label': '油尖旺區',
        'value': 'YJWQ',
        'parent': 'JL'
    },{
        'label': '深水埗區',
        'value': 'SSPQ',
        'parent': 'JL'
    },{
        'label': '觀塘區',
        'value': 'GTQ',
        'parent': 'JL'
    },{
        'label': '黃大仙區',
        'value': 'HDXQ',
        'parent': 'JL'
    },{
        'label': '旺角',
        'value': 'WJ',
        'parent': 'JL'
    }
];

let XinJie = [
    {
        'label': '元朗區',
        'value': 'YLQ',
        'parent': 'XJ'
    },{
        'label': '北區',
        'value': 'BQ',
        'parent': 'XJ'
    },{
        'label': '大埔區',
        'value': 'DPQ',
        'parent': 'XJ'
    },{
        'label': '沙田區',
        'value': 'STQ',
        'parent': 'XJ'
    },{
        'label': '荃灣區',
        'value': 'QWQ',
        'parent': 'XJ'
    },{
        'label': '葵青區',
        'value': 'KQQ',
        'parent': 'XJ'
    },{
        'label': '西貢區',
        'value': 'XGQ',
        'parent': 'XJ'
    },{
        'label': '離島區',
        'value': 'LDQ',
        'parent': 'XJ'
    },{
        'label': '天水圍',
        'value': 'TSW',
        'parent': 'XJ'
    }
];

// 中西區
// 南區
// 東區
// 灣仔區
// 九龍城區
// 油尖旺區
// 深水埗區
// 觀塘區
// 黃大仙區
// 元朗區
// 北區
// 大埔區
// 屯門區
// 沙田區
// 荃灣區
// 葵青區
// 西貢區
// 離島區

const HongKongAreaJson = {
    "en" : {
        
    },
    "cn" : [{
        "label": "香港島",
        "value": "HKD",
        "parent": "0",
        "children" : HKD
    },{
        "label": "九龍",
        "value": "JL",
        "parent": "0",
        "children" : JiuLong
    },{
        "label": "新界",
        "value": "XJ",
        "parent": "0",
        "children": XinJie
    }],
    tc : {

    },
};

export default HongKongAreaJson